import React, { useState, useEffect, useRef } from 'react';
import fitty from 'fitty';

import { sportUtilities } from 'utilities/sportUtilities';
import revealImg from 'theme/assets/images/reveal.png';
import config from 'theme/config';

import './CardFace.scss';

export interface ICardFaceDetails {
  team: string;
  playerNo: string;
  position: string;
  style?: string;
}

interface ICardFace {
  playerName?: string;
  teamCode?: string;
  maxFontSize?: number;
  minFontSize?: number;
  multiLine?: boolean;
  details?: ICardFaceDetails;
}

const CardFace = (props: ICardFace) => {
  const playerNameRef = useRef<HTMLDivElement>(null);
  const [shirtPath, setShirtPath] = useState<string>('');

  const getCardDetails = () => {
    if (!props.details) {
      return null;
    }

    const text = [];
    if (config.settings.showShirtNumbers && props.details.playerNo) {
      text.push(`#${props.details.playerNo}`);
    }
    if (props.details.position) {
      text.push(props.details.position);
    }

    return (
      <div className={`card-face__details ${props.details.style ?? ''}`}>
        <div className="card-face__team">{props.details.team}</div>
        <div className="card-face__number-position">{text.join(' | ')}</div>
      </div>
    );
  };

  if (!shirtPath) {
    if (props.teamCode) {
      sportUtilities.getShirtImage(props.teamCode.toLowerCase(), setShirtPath);
    } else {
      setShirtPath(revealImg);
    }
  }

  useEffect(() => {
    if (playerNameRef.current) {
      fitty(playerNameRef.current, {
        minSize: props.minFontSize || 12,
        maxSize: props.maxFontSize || 16,
        multiLine: props.multiLine || false
      });
    }
  }, [props.minFontSize, props.maxFontSize, props.multiLine]);

  return (
    <div className={`card-face ${props.details ? `card-face--has-player-details` : ''}`} style={{ backgroundImage: `url("${shirtPath}")` }} data-testid="card-face">
      {props.playerName && (
        <div className="card-face__name">
          <div className="card-face__name-text" ref={playerNameRef}>
            {props.playerName}
          </div>
        </div>
      )}
      {getCardDetails()}
    </div>
  );
};

export default CardFace;
